<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>

              <div class="flex justify-center">
                <img
                  v-if="selectedFileUrl || store.itensForm.imagesName"
                  :src="selectedFileUrl ?? fileUrl + store.itensForm.imagesName"
                  :key="store.itensForm.imagesName"
                  alt="Foto do setor"
                  class="mt-10 mb-auto rounded-md w-60 max-h-60 hidden md:block"
                /> 
              </div>
            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- tipo -->
                <div class="md:col-span-2">
                  <div class="md:col-span-2 mt-1.5">
                    <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="itensForm.type">
                      Tipo <a class="text-red-600 ml-1">*</a>
                    </label>
                    <div
                      class="h-10 flex rounded items-center"
                    >
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="types"
                        :initialValue="store.itensForm.type"
                        @selected-data="(val) => (store.itensForm.type = val)"
                      />
                    </div>
                  </div>

                  <span
                    name="itensForm.type"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- sector name -> local -->
                <div class="md:col-span-3">
                  <BaseInput
                    type="text"
                    name="itensForm.name"
                    v-model="store.itensForm.name"
                    :info="'Localização'"
                    label="Localização do item"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.itensForm.name = undefined" />
                    </template>
                  </BaseInput>

                  <span name="itensForm.name" class="text-red-600 text-sm" />
                </div>

                <!-- forms -->
                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div :key="selectedComponent" class="lg:col-span-2" v-if="selectedComponent">
                      <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">
                        <component 
                          :is="selectedComponent" 
                          :key="selectedComponent" 
                        />
                      </div>
                    </div>
                  </Transition>
                </div> 

                <!-- próxima inspeção -->
                <div class="md:col-span-2">
                  <div class="flex">
                    <BaseInput
                      type="number"
                      name="itensForm.check_every"
                      v-model="store.itensForm.check_every"
                      :min="1"
                      :info="'Próxima inspeção em'"
                      label="Próxima inspeção"
                      :required-field="false"
                      :activeDefault="false"
                      :center="true"
                    >
                      <template #append>
                        <CleanInputButton
                          @click="store.itensForm.check_every = null"
                        />
                      </template>
                    </BaseInput>
  
                    <label class="mt-auto mb-auto text-base pt-4" v-if="store.itensForm.check_every">
                      dias
                    </label>
                  </div>
                </div>

                <!-- próxima verificação -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="date"
                    name="itensForm.next_check"
                    v-model="store.itensForm.next_check"
                    :info="'Próxima inspeção em'"
                    label="Próxima manutenção"
                    :required-field="false"
                    :activeDefault="true"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.itensForm.next_check = null"
                      />
                    </template>
                  </BaseInput>

                  <span name="itensForm.next_check" class="text-red-600 text-sm" />
                </div>

                <!-- descrição -->
                <div class="md:col-span-5">
                  <BaseInput
                    type="text"
                    name="itensForm.description"
                    v-model="store.itensForm.description"
                    :info="'Observações / Decrição'"
                    label="Observações / Decrição"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.itensForm.description = undefined" />
                    </template>
                  </BaseInput>
                </div>

                <!-- fluxo da imagem -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl || store.itensForm.imagesName"
                    :src="selectedFileUrl ?? fileUrl + store.itensForm.imagesName"
                    alt="Foto do setor"
                    class="mt-2 rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <div class="md:col-span-5 mt-2 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                  >
                    <!-- <i class="fa-solid fa-helmet-safety"></i> -->

                    <div class="flex mt-auto mb-auto h-full">
                      <div class="w-full mt-auto mb-auto flex justify-center">
                        <component 
                          :is="selectedFileName ? image : fileImage"
                          class="w-5 h-5 mr-1" 
                          :class="[
                            selectedFileName ? 'text-green-500' : 'text-gray-500'
                          ]"
                        />
    
                        Foto
                      </div>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />
                  
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SistemaResgateForm from './forms/sistemaResgateForm.vue';
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue';
import ExtinguisherForm from './forms/extinguisherForm.vue';
import LightingForm from './forms/lightingForm.vue';
import HydrantForm from './forms/hydrantForm.vue';
import SirenForm from './forms/sirenForm.vue';
import BaseInput from '@/components/Inputs/BaseInput.vue';
import { showToast as toast } from '@/helpers/UseToasts'
import { dataExtinguisher } from '../store'
import { types } from '../lookups/form';
import { markRaw } from 'vue';

import { 
  PhFileImage,
  PhImage
} from '@phosphor-icons/vue';

export default({
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
    ExtinguisherForm,
    HydrantForm,
    LightingForm,
    SirenForm,
    SistemaResgateForm,
  },
  props: {
    descriptionTitle: String,
  },
  data () {
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
    const componentExtinguisherForm = markRaw(ExtinguisherForm)
    const componentHydrantForm = markRaw(HydrantForm)
    const componentLightingForm = markRaw(LightingForm)
    const componentSirenForm = markRaw(SirenForm)
    const componentResgateForm = markRaw(SistemaResgateForm)

    const fileImage = markRaw(PhFileImage)
    const image = markRaw(PhImage)

    return {
      fileImage,
      image,
      componentExtinguisherForm,
      componentHydrantForm,
      componentLightingForm,
      componentSirenForm,
      componentResgateForm,

      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataExtinguisher.state,
      dataExtinguisher,
      types,
      fileUrl,
      toast,
      markRaw,
      lastComponentActive: undefined
    }
  },
  computed: {
    selectedComponent() {
      let type = this.store.itensForm?.type?.value;

      const componentsMap = {
        extintor: this.componentExtinguisherForm,
        hidrante: this.componentHydrantForm,
        iluminacao: this.componentLightingForm,
        acionador_sirene: this.componentSirenForm,
        sis_resgate: this.componentResgateForm,
      };

      if(componentsMap[type] == undefined)
        this.lastComponentActive = this.lastComponentActive
      else 
        this.lastComponentActive = componentsMap[type]

      if(componentsMap[type] == undefined && typeof this.store.itensForm?.type == 'string') {
        types.find((i) => {
          return i.name == this.store.itensForm?.type ? type = i.value : undefined
        })
      }

      return componentsMap[type] || this.lastComponentActive;
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)
          
          this.store.itensForm.imagesName = this.selectedFileName
          this.store.itensForm.images = file
        } else 
          return this.toast(
            'Protege informa: ',
            'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
            'info'
          )
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>